import styled from "styled-components";

import{ Image } from "../../../../atoms";

export const BookingConfirmationImage = styled(Image)`
  max-width: 100px;
  max-height: 100px;
  margin-top: 50px;
  margin-bottom: 10px;
`;